import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthState } from '../context'

const AppRoutes = ({ Component, isPrivate }) => {
	const userDetails = useAuthState();
	return isPrivate && !userDetails.user ? (
		<Navigate
			to={ "/login" }
		/>
	) : (
		<Component />
	);
}

export default AppRoutes;